// FF Accordion JS
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.ff-accordion__trigger');
  if (!trigger) return;

  const item = trigger.closest('.ff-accordion__item');
  const container = trigger.closest('[data-ff-accordion]');
  if (!item || !container) return;

  const allowMultiple =
    container.getAttribute('data-allow-multiple') === 'true';

  const panelId = trigger.getAttribute('aria-controls');
  const panel = document.getElementById(panelId);
  if (!panel) return;

  const isOpen = trigger.getAttribute('aria-expanded') === 'true';

  // Agar multiple allowed nahi to baaki saare close karo
  if (!allowMultiple) {
    container.querySelectorAll('.ff-accordion__trigger.is-open').forEach(function (btn) {
      if (btn === trigger) return;
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });

    container.querySelectorAll('.ff-accordion__panel.is-open').forEach(function (p) {
      if (p === panel) return;
      p.classList.remove('is-open');
      p.setAttribute('hidden', 'hidden');
    });
  }

  // Current toggle
  if (isOpen) {
    trigger.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    panel.setAttribute('hidden', 'hidden');
  } else {
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    panel.removeAttribute('hidden');
  }
});
